import React, { useEffect, useState } from 'react';

interface LazyImageProps {
  src?: string;
  alt?: string;
  className?: string;
}

export const LazyImage: React.FC<LazyImageProps> = ({
  src,
  className,
  alt = ''
}) => {
  const [imageSrc, setImageSrc] = useState<string | null | undefined>(null);
  const [imageRef, setImageRef] = useState<HTMLImageElement | null>(null);

  useEffect(() => {
    let observer: IntersectionObserver | undefined;

    if (imageRef && imageSrc !== src) {
      if (IntersectionObserver) {
        observer = new IntersectionObserver(
          entries => {
            entries.forEach(entry => {
              if (entry.intersectionRatio > 0 || entry.isIntersecting) {
                setImageSrc(src);
                observer?.unobserve(imageRef);
              }
            });
          },
          {
            threshold: 0.01
          }
        );
        observer.observe(imageRef);
      } else {
        setImageSrc(src);
      }
    }
    return () => {
      if (observer && observer.unobserve) {
        observer.unobserve(imageRef!);
      }
    };
  }, [src, imageSrc, imageRef]);

  return (
    <img
      ref={setImageRef}
      src={imageSrc ?? undefined}
      alt={alt}
      className={className}
    />
  );
};
